import { folderCard } from './cards';

import {
  Defaults,
  Traits,
} from './shared';

import { ICON_BUTTON_FOLDER } from './../../../const/icons';

import { COMP_BUTTON_FOLDER } from './../../../const/components';

import { FIELD_FOLDER_SELECTOR } from './../../../const/traits';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const Folder = (editor, options:any = {}) => {

  (FIELD_FOLDER_SELECTOR as any).at = 9;

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_FOLDER,
    displayIcon: ICON_BUTTON_FOLDER,
    model: {
      defaults: { ...Defaults,
        name: 'Folder',
        traits: [ ...Traits, FIELD_FOLDER_SELECTOR]
      }
    },
    cardOnRender() {
      return folderCard.call(this);
    }
  });
}